export default "__VITE_ASSET__D$4wV5Iq__"